import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { ModalController } from '@ionic/angular';
import { ITesis, ITesisModalKontrol } from '@shared/models/interfaces';

@Component({
  selector: 'app-facilities-list',
  templateUrl: './facilities-list.component.html',
  styleUrls: ['./facilities-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class FacilitiesListComponent implements OnInit {
  @Input() tesisModalKontrol: ITesisModalKontrol;

  public tesisler: ITesis[];
  public selectedFacId: number;

  constructor(
    private modalController: ModalController,
    public app: AppService,
  ) { }

  ngOnInit(): void {
    this.getTesis();
  }

  getTesis() {
    this.app.getTesisList$().subscribe(response => {
      this.tesisler = response;
    });
  }

  onSelect(tesis: ITesis) {
    this.selectedFacId = this.selectedFacId === tesis.facId ? undefined : tesis.facId;
  }

  continue(selected: number) {
    this.modalController.dismiss({
      dismissed: true,
      selected
    });
  }
  
  async dismiss(dismissed: boolean) {
    await this.modalController.getTop();
    await this.modalController.dismiss(dismissed);
  }
}
